
import Vue from "vue";

export default Vue.component("SHTableSessionCardSkeleton", {
  components: {
    QSkeleton: () => import("../elements/QSkeleton.vue"),
  },
});
